
let isSavingTO: NodeJS.Timeout = null;

class LinearSaveService {
  private vm: {isSaving?: boolean};

  __getDataForTests() {
    return {
      getVM: () => {
        return this.vm;
      },
      getTimeout: () => {
        return isSavingTO;
      }
    }
  }

  /**
   * pass in the `vm` (view model) from AngularJS controller, so the HTML can efficiently bind to it, rather than
   * trying to use getters, as they get called with every render, which is inefficient in AngularJS.
   */
  init(vm: {isSaving?: boolean}) {
    this.vm = vm;
    this.vm.isSaving = false;
  }

  // NBI-7939: calls 'save', but uses 'isSaving' condition to prevent more calls while still waiting for save to complete
  linearSave(saveCB: (blockedCB: () => void) => void) {
    this.removeLinearSave(false);

    /**
     * after 10 seconds stop disabling the save button, just in case something isn't working as it should, we
     * don't want to block the user from saving forever
     */
    isSavingTO = setTimeout(() => {
      this.removeLinearSave();
    }, 10000);

    this.vm.isSaving = true;
    saveCB(() => {
      this.removeLinearSave();
    });
  }

  removeLinearSave(includeVar = true) {
    if (isSavingTO) {
      clearTimeout(isSavingTO);
      isSavingTO = null;
    }
    if (includeVar) {
      this.vm.isSaving = false;
    }
  }

}

const instance = new LinearSaveService();
export default instance as LinearSaveService;
